import { getCloudFunctionUrl } from "../auth/firebase";

export const corsproxyRequest = async (url: string) => {
  try {
    // First try a direct fetch
    const directResponse = await fetch(url);
    if (!directResponse.ok) {
      throw new Error("Network response was not OK");
    }
    return await directResponse.json();
  } catch {
    // If direct fetch fails (likely due to CORS), use the proxy
    return new Promise((resolve, reject) => {
      fetch(getCloudFunctionUrl("apiNoCorsFetch"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url }),
      }).then((res) => {
        if (!res.ok) {
          reject(new Error("Network response was not OK"));
          return;
        }
        res.json().then(resolve);
      });
    });
  }
};
export const corsFetch = (url: string) => {
  return fetch(getCloudFunctionUrl("apiNoCorsFetch"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ url }),
  });
};
